import { cn } from "@/utils/cn";
import { Icon } from "@/components/Icon/Icon";
import type { Phase } from "@/utils/types/ui";
import type { IconName } from "@/utils/types/ui";

// Make and Assess are visible and clickable during the Pilot release —
// transitions still happen, but the destination phase is rendered behind a
// PilotBarrier (see WorkbenchPage). Locking the segmented buttons would
// hide that there's a Make/Assess flow at all.
const PHASES: { id: Phase; label: string; icon: IconName; hint: string }[] = [
  { id: "design", label: "Design", icon: "atom", hint: "Sensory targeting" },
  { id: "make", label: "Make", icon: "beaker", hint: "Pilot batch & process" },
  { id: "assess", label: "Assess", icon: "target", hint: "Panel & QC review" },
];

type PhaseSegmentedProps = {
  value: Phase;
  onChange: (value: Phase) => void;
};

export function PhaseSegmented({ value, onChange }: PhaseSegmentedProps) {
  const idx = Math.max(0, PHASES.findIndex((p) => p.id === value));
  return (
    <div role="tablist" aria-label="Phase" className="phase-segmented">
      <div
        aria-hidden
        className="phase-segmented-pill"
        style={{ left: `calc(${(idx * 100) / 3}% + 3px)` }}
      />
      {PHASES.map((p) => {
        const active = p.id === value;
        return (
          <button
            key={p.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(p.id)}
            title={p.hint}
            className={cn("phase-segmented-btn", active && "active")}
          >
            <Icon name={p.icon} size={11} />
            <span>{p.label}</span>
          </button>
        );
      })}
    </div>
  );
}
